import { defer, Observable } from 'rxjs';

/**
 * An operator which invokes a callback upon subscription via defer.
 *
 * @param callback - The callback to invoke
 */
export function prepare<T>(callback: () => void): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    defer(() => {
      callback();
      return source;
    });
}
